module.exports = __webpack_public_path__ + "static/media/communicator.7df0cf38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/commanders/communicator.png
// module id = 2073
// module chunks = 0